import * as constants from "./actions";
import axios from "@/plugins/axios.js";

function getDefaultState() {
  return {
    addons: {
      status: null,
      data: [],
      error: null,
    },

    addon: {
      status: null,
      data: {},
      error: null,
    },
    taxes: {
      status: null,
      data: [],
      error: null,
    },
  };
}
const actions = {
  [constants.GET_ADDONS]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_ADDONS);
      const response = await axios.get("addon/getAddons", {
        params: payload,
      });
      commit(constants.GET_ADDONS_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_ADDONS_ERROR, error);
      throw error.response;
    }
  },
  [constants.POST_ADDON]: async ({ commit }, payload) => {
    try {
      commit(constants.POST_ADDON);
      const response = await axios.post("addon/createAndUpdate", payload);
      commit(constants.POST_ADDON_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.POST_ADDON_ERROR, error);
      throw error.response;
    }
  },
  [constants.DELETE_ADDON]: async ({ commit }, payload) => {
    try {
      commit(constants.DELETE_ADDON);
      const response = await axios.delete("addon/deleteAddon", {
        params: payload,
      });
      commit(constants.DELETE_ADDON_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.DELETE_ADDON_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_ADDONS_TAXES]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_ADDONS_TAXES);
      const response = await axios.get("taxes/getTaxByVehicle", {
        params: payload,
      });
      commit(constants.GET_ADDONS_TAXES_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_ADDONS_TAXES_ERROR, error);
      throw error.response;
    }
  },

};

const mutations = {
  [constants.GET_ADDONS]: (state) => {
    state.addons.data = [];
    state.addons.status = "fetching";
  },
  [constants.GET_ADDONS_SUCCESS]: (state, response) => {
    state.addons.status = "success";
    state.addons.data = response;
  },
  [constants.GET_ADDONS_ERROR]: (state, error) => {
    state.addons.status = "error";
    state.addons.error = error;
  },
  [constants.POST_ADDON]: (state) => {
    state.addon.data = {};
    state.addon.status = "fetching";
  },
  [constants.POST_ADDON_SUCCESS]: (state, response) => {
    state.addon.status = "success";
    state.addon.data = response;
  },
  [constants.POST_ADDON_ERROR]: (state, error) => {
    state.addon.status = "error";
    state.addon.error = error;
  },
  [constants.DELETE_ADDON]: (state) => {
    state.addon.data = {};
    state.addon.status = "fetching";
  },
  [constants.DELETE_ADDON_SUCCESS]: (state, response) => {
    state.addon.status = "success";
    state.addon.data = response;
  },
  [constants.DELETE_ADDON_ERROR]: (state, error) => {
    state.addon.status = "error";
    state.addon.error = error;
  },
  [constants.GET_ADDONS_TAXES]: (state) => {
    state.taxes.data = [];
    state.taxes.status = "fetching";
  },
  [constants.GET_ADDONS_TAXES_SUCCESS]: (state, response) => {
    state.taxes.status = "success";
    state.taxes.data = response.taxes;
  },
  [constants.GET_ADDONS_TAXES_ERROR]: (state, error) => {
    state.taxes.status = "error";
    state.taxes.error = error;
  },


};
export default {
  state: getDefaultState(),
  actions,
  mutations,
};
